import React, { useState, useEffect } from "react";
import { Table, Container, Spinner } from "react-bootstrap";
import { Pencil, Trash } from "react-bootstrap-icons";
import { fetchAPI } from "../utils/fetchAPI";
import { getEntityTypeDisplayName } from "../utils/entityType";

interface QrCode {
  qrCode: string;
  entityId: number;
  entityType: number;
  entityName: string;
}

interface QrListProps {
  qrCodes: QrCode[];
  loading: boolean;
  onEdit: (qr: QrCode) => void;
  onDelete: (qr: QrCode) => void;
}

const QrList: React.FC<QrListProps> = ({ qrCodes, loading, onEdit, onDelete }) => {
  if (qrCodes.length === 0) {
    return (
      <Container className="text-center mt-4">
        <p>Nie znaleziono kodów QR.</p>
      </Container>
    );
  }

  return (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>Kod QR</th>
          <th>Nazwa</th>
          <th>Typ</th>
          <th className="text-end">Akcje</th>
        </tr>
      </thead>
      <tbody>
        {qrCodes.map((qr, index) => (
          <tr key={index}>
            <td>{qr.qrCode}</td>
            <td>{qr.entityName}</td>
            <td>{getEntityTypeDisplayName(qr.entityType)}</td>
            <td className="text-end">
              <button className="btn btn-link text-primary p-0 me-2" onClick={() => onEdit(qr)}>
                <Pencil size={20} />
              </button>
              <button className="btn btn-link text-danger p-0" onClick={() => onDelete(qr)}>
                <Trash size={20} />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default QrList;
